var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import { AccordionSet, Accordion, Checkbox, Button, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { RecekTextField, RecekSelection } from "./inputs";
import { formatPublisherLabel } from "../utils/formatPublisherLabel";
export var PublisherPrefixFilters = function (_a) {
    var filters = _a.filters, onFilterChange = _a.onFilterChange, onApplyFilters = _a.onApplyFilters, hasUnappliedChanges = _a.hasUnappliedChanges, agencyOptions = _a.agencyOptions, rangeOptions = _a.rangeOptions, agencyLoading = _a.agencyLoading, rangeLoading = _a.rangeLoading, onAgencyInput = _a.onAgencyInput, onRangeInput = _a.onRangeInput, onPublisherInput = _a.onPublisherInput, publishers = _a.publishers, publishersLoading = _a.publishersLoading, selectedPublisher = _a.selectedPublisher, temporaryPublisherId = _a.temporaryPublisherId, _b = _a.isPublisherGuarantor, isPublisherGuarantor = _b === void 0 ? false : _b, selectedAgencyOption = _a.selectedAgencyOption, selectedRangeOption = _a.selectedRangeOption;
    var formatMessage = useIntl().formatMessage;
    var agencyDataOptions = __spreadArray(__spreadArray([
        {
            value: "",
            label: formatMessage({
                id: "ui-br-agency.collectionsList.select.option.all",
            }),
        }
    ], (selectedAgencyOption &&
        selectedAgencyOption.value &&
        selectedAgencyOption.label &&
        !agencyOptions.some(function (o) { return o.value === selectedAgencyOption.value; })
        ? [selectedAgencyOption]
        : []), true), agencyOptions, true);
    var rangeDataOptions = __spreadArray(__spreadArray([
        {
            value: "",
            label: formatMessage({
                id: "ui-br-agency.collectionsList.select.option.all",
            }),
        }
    ], (selectedRangeOption &&
        selectedRangeOption.value &&
        selectedRangeOption.label &&
        !rangeOptions.some(function (o) { return o.value === selectedRangeOption.value; })
        ? [selectedRangeOption]
        : []), true), rangeOptions, true);
    return (React.createElement("form", { onSubmit: function (e) {
            e.preventDefault();
            onApplyFilters();
        } },
        React.createElement(AccordionSet, null,
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.publisher-prefix.filter.search",
                }), id: "publisher-prefix-search-filter", displayWhenClosed: React.createElement("div", null, filters.value && (React.createElement("div", null,
                    React.createElement(FormattedMessage, { id: "ui-br-agency.publisher-prefix.filter.value" }),
                    ": ",
                    filters.value))) },
                React.createElement(RecekTextField, { labelId: "ui-br-agency.publisher-prefix.filter.value", placeholder: formatMessage({
                        id: "ui-br-agency.publisher-prefix.filter.value.placeholder",
                    }), value: filters.value, onChange: function (e) {
                        return onFilterChange("value", e.target.value);
                    }, marginBottom0: true })),
            !isPublisherGuarantor && (React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.publisher-prefix.filter.agencyPrefix",
                }), separator: false },
                React.createElement(RecekSelection, { labelId: "ui-br-agency.publisher-prefix.filter.agencyPrefix", showLabel: false, asyncFilter: true, value: filters.agencyPrefixId || "", loading: agencyLoading, onFilter: onAgencyInput, onChange: function (value) {
                        return onFilterChange("agencyPrefixId", value);
                    }, dataOptions: agencyDataOptions }))),
            !isPublisherGuarantor && (React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.publisher-prefix.filter.prefixRange",
                }), separator: false },
                React.createElement(RecekSelection, { labelId: "ui-br-agency.publisher-prefix.filter.prefixRange", showLabel: false, asyncFilter: true, value: filters.publisherPrefixRangeId || "", loading: rangeLoading, onFilter: onRangeInput, onChange: function (value) {
                        return onFilterChange("publisherPrefixRangeId", value);
                    }, dataOptions: rangeDataOptions }))),
            !isPublisherGuarantor && (React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.publisher-prefix.filter.publisher",
                }), separator: false },
                React.createElement(RecekSelection, { labelId: "ui-br-agency.publisher-prefix.filter.publisher", showLabel: false, asyncFilter: true, value: selectedPublisher
                        ? selectedPublisher.sourceId || ""
                        : temporaryPublisherId || "", loading: publishersLoading, onFilter: onPublisherInput, onChange: function (value) { return onFilterChange("publisherId", value); }, dataOptions: __spreadArray(__spreadArray([
                        {
                            value: "",
                            label: formatMessage({
                                id: "ui-br-agency.collectionsList.select.option.all",
                            }),
                        }
                    ], (selectedPublisher &&
                        selectedPublisher.sourceId &&
                        selectedPublisher.name &&
                        !publishers.some(function (publisher) {
                            return publisher.sourceId === selectedPublisher.sourceId;
                        })
                        ? [
                            {
                                value: selectedPublisher.sourceId,
                                label: formatPublisherLabel(selectedPublisher, formatMessage),
                            },
                        ]
                        : []), true), publishers.map(function (publisher) { return ({
                        value: publisher.sourceId || "",
                        label: formatPublisherLabel(publisher, formatMessage),
                    }); }), true) }))),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.publisher-prefix.filter.status",
                }), id: "publisher-prefix-status-filter" },
                React.createElement(Checkbox, { label: formatMessage({
                        id: "ui-br-agency.publisher-prefix.filter.label.showClosed",
                    }), checked: filters.showClosed, onChange: function (e) {
                        return onFilterChange("showClosed", e.target.checked);
                    } }))),
        React.createElement(Button, { type: "submit", buttonStyle: "primary", fullWidth: true, disabled: !hasUnappliedChanges, marginBottom0: true },
            React.createElement(FormattedMessage, { id: "ui-br-agency.button.applyFilters" }))));
};
